import axios from 'axios';

const baseURL = `${process.env.REACT_APP_INTEGRATIONS_SERVICE_URL}/hubspot/`;
const hostName = process.env.REACT_APP_HOST_NAME;

const HubSpotAPI = axios.create({
	baseURL,
	headers: {
		host_name: hostName,
		'x-host': hostName,
		'X-API-KEY': `${process.env.REACT_APP_INTEFGRATIONS_SERVICE_API_KEY}`
	}
});

export default HubSpotAPI;
